import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { routesFactory } from './language.routes';
import { DeviceDetectorService } from 'ngx-device-detector';

import {
  ROUTES
} from '@angular/router';

@NgModule({
  imports: [
    StoreModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{
    provide: ROUTES,
    useFactory: routesFactory,
    multi: true,
    deps: [DeviceDetectorService]
  }],
})
export class LanguageModule { }